import React from "react";
import PropTypes, { string } from "prop-types";
// import TextField from '@material-ui/core/TextField';
import TextField from '@mui/material/TextField';
import { InputLabel, Paper, Tooltip } from "@mui/material";
import ManageSearchRoundedIcon from '@mui/icons-material/ManageSearchRounded';
import DraggableDialog from "../CustomDialogs/DraggableDialog";

import DocGroupList from "./Components/docGroupList";
import axios from "axios";
import { genURL } from "../../_getjson";
const styles = {
    textField: {
        fontFamily: "Customfont !important"
    }
}
export default function CustomDocGroupInput(props) {
    const { label, id, defaultValue, helperText, inputType, tabIndex, placeholder, tablename } = props
    const [inputData, setInputData] = React.useState(defaultValue);
    const [inputNameData, setNameInputData] = React.useState("");
    const [inputDataShow, setInputDataShow] = React.useState("");
    const [inputChangData, setInputChangData] = React.useState(false);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [titleDialog, setTitleDialog] = React.useState("เลือกกลุ่มเอกสาร");

    React.useEffect(() => {
        console.log(tablename)
        return () => {
        }
    }, [])

    React.useEffect(() => {
        setInputData(defaultValue === null ? "" : defaultValue)
        return () => {
        }
    }, [defaultValue])

    React.useEffect(() => {

        props.resData(inputData)

        return () => {
        }
    }, [inputData])

    const handleChange = (event) => {
        // event.preventDefault(); 
        setInputData(event.target.value === "" ? null : event.target.value);
        setInputDataShow(event.target.value === "" ? null : event.target.value);

        setInputChangData(true)
    }



    const getData = async () => {

        let url = `CSDOCGROUPUSER/Getdata?Usercode=` + localStorage.getItem('Username') + `&tablename=` + tablename + `&Code=` + inputData
        console.log("url" + url);
        await axios.get(genURL(url)).then(e => {

            console.log("getData", e)

            if (e.data.length > 0) {
                setNameInputData(e.data[0].DOCNAME);
                setInputChangData(false)

            } else {
                setNameInputData("")
                setInputData("")
                setInputDataShow("")
            }
        })

    }
    const onBlur = async (event) => {
        if (inputChangData === true) {
            getData(event.target.value)
        } else {
            setInputDataShow(inputNameData);
        }
    }
    const handleKeyDown = (event) => {
        // event.preventDefault();

        if (event.key === "Enter") {
            if (inputChangData === true) {
                getData(inputData)
            } else {
                setInputDataShow(inputNameData);
            }
            try {
                props.keyDown(event.key)
            }
            catch (error) {
                console.log("handleKeyDown err", error);
            }
        }
    }

    const handleSearchClick = () => {
        // console.log("testxxxxx handleSearchClick"); 
        setOpenDialog(true)
    }

    const resultData = async (e) => {
        let code = ""
        let name = ""
        // for (let index = 0; index < e.length; index++) {
        code = await e[0].code
        //  code += await index > -1 && index < e.length - 1 ? "," : "";

        name = await e[0].name
        // code += await index > -1 && index < e.length - 1 ? "," : "";
        // }
        await setInputData(code)
        await setNameInputData(name)
        await setInputDataShow(name)
        await setOpenDialog(false)


    }

    const handleFocus = event => {
        event.preventDefault();
        console.log(event)
        setInputDataShow(inputData)
    }
    return (
        <>
            <Paper
                elevation={0}
                component="div"
                sx={{
                    pl: '5px',
                    pt: '1px',
                    m: "0px",
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: "#eee",
                    border: "1px solid #ccc",
                    verticalAlign: "middle",

                }}

            >
                <Tooltip title={label}>
                    <InputLabel sx={{
                        width: "140px", whiteSpace: "nowrap",
                        fontSize: "16px",
                        fontFamily: "Customfont !important",
                        color: "black",
                        verticalAlign: "middle"
                    }}  >{label}</InputLabel>
                </Tooltip>

                <TextField
                    sx={{
                        //     "& label.Mui-focused": {
                        //         display: "none",
                        //     },
                        //     "& legend": {
                        //         display: "none",
                        //     },
                        backgroundColor: "#fff",
                        fontFamily: "Customfont"
                        //     marginTop: "0px",
                    }}
                    hiddenLabel
                    id={id}
                    defaultValue={defaultValue}
                    onChange={handleChange}
                    value={inputDataShow}
                    helperText={helperText}
                    variant="standard"
                    size="small"
                    type={inputType}
                    fullWidth
                    tabIndex={tabIndex}
                    placeholder={placeholder}
                    onBlur={e => onBlur(e)}
                    onKeyDown={handleKeyDown}
                    onFocus={handleFocus}
                    inputProps={{
                        style: {
                            fontSize: "0.9rem",
                            fontFamily: "Customfont"
                        }
                    }}

                />
                <ManageSearchRoundedIcon sx={{ cursor: "pointer" }} onClick={_ => handleSearchClick()} />
            </Paper>
            <DraggableDialog open={openDialog} title={titleDialog} closeDialog={e => setOpenDialog(e)} >
                <DocGroupList resultData={e => resultData(e)} tablename={tablename} />
            </DraggableDialog>

        </>
    );
}
CustomDocGroupInput.propTypes = {
    label: PropTypes.string,
    id: PropTypes.string,
    defaultValue: PropTypes.string,
    helperText: PropTypes.string,
    inputType: PropTypes.oneOf(["button", "checkbox", "color", "date", "datetime-local", "email", "file", "hidden", "image", "month", "number", "email", "password", "radio", "range", "reset", "search", "submit", "tel", "text", "time-local", "url", "file", "week"]),
    placeholder: PropTypes.string,
    tabIndex: PropTypes.string,
    tablename: PropTypes.string.isRequired
}





